import { Image, ImageProps } from "react-bootstrap";
import styles from "./social.module.css";
import classNames from "classnames";
import { useEffect, useState } from "react";
import * as EBIC from "@ebic-bbrm/types";
import UserIcon from "../../assets/icons/person.png";

interface UserAvatarProps extends ImageProps {
  user?: Pick<EBIC.User.UserInfo, "user_id" | "user_pic"> | null;
}

/**
 * If `src` is passed in props, it will always take precedence.
 */
export default function UserAvatar({
  user,
  className,
  alt = "Avatar",
  roundedCircle = true,
  title,
  onError,
  style,
  src: srcPassedInProps,
  ...props
}: UserAvatarProps) {
  const [src, setSrc] = useState<string | null>(user?.user_pic ?? null);

  useEffect(() => {
    setSrc(user?.user_pic ?? null);
  }, [user?.user_pic]);

  return (
    <Image
      className={classNames(
        styles.userAvatar,
        className,
        !srcPassedInProps && !src && "bg-secondary p-1"
      )}
      alt={alt}
      roundedCircle={roundedCircle}
      src={(srcPassedInProps || src) ?? UserIcon}
      style={{
        objectFit: "cover",
        ...style,
      }}
      {...props}
    />
  );
}
